import * as React from "react";

import { useTranslate } from "@hooks/useTranslate";

import { Modal } from "@app/containers";
import { OPTIONS_MODALS } from "@app/pages/ClientDashboard/OptionsDashboard.modals";

export const HolidayModificationBlocked = (): React.ReactElement => (
  <Modal
    title={useTranslate()(
      "batmaid_pwa_my_cleanings.holiday_modification_blocked",
    )}
    id={OPTIONS_MODALS.HOLIDAY_MODIFICATION_BLOCKED}
  >
    {useTranslate()("batmaid_pwa_my_cleanings.cannot_modify_ongoing_holiday")}
  </Modal>
);

HolidayModificationBlocked.displayName = "HolidayModificationBlocked";
